import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchAdminOrders } from '../services/orders';

const AdminNotificationsContext = createContext(null);

export function AdminNotificationsProvider({ children }) {
  const [pendingCount, setPendingCount] = useState(0);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPending = useCallback(async () => {
    try {
      const res = await fetchAdminOrders({ status: 'pending', per_page: 10, page: 1 });
      const total = res.total ?? (Array.isArray(res.data) ? res.data.length : 0);
      const list = Array.isArray(res.data) ? res.data : [];
      setPendingCount(total);
      setPendingOrders(list);
    } catch (err) {
      console.error('Failed to load pending orders for notifications', err);
      setPendingCount(0);
      setPendingOrders([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadPending();
    const interval = setInterval(loadPending, 60000);
    return () => clearInterval(interval);
  }, [loadPending]);

  const value = {
    pendingCount,
    pendingOrders,
    loading,
    refetch: loadPending,
  };

  return (
    <AdminNotificationsContext.Provider value={value}>
      {children}
    </AdminNotificationsContext.Provider>
  );
}

export function useAdminNotifications() {
  const ctx = useContext(AdminNotificationsContext);
  if (!ctx) {
    throw new Error('useAdminNotifications must be used within AdminNotificationsProvider');
  }
  return ctx;
}
